import { render, staticRenderFns } from "./CrosswordCustomStyleModal.vue?vue&type=template&id=4b860862&scoped=true"
import script from "./CrosswordCustomStyleModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CrosswordCustomStyleModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CrosswordCustomStyleModal.vue?vue&type=style&index=0&id=4b860862&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b860862",
  null
  
)

export default component.exports